// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { ApplicationWithRelationsSchema } from './ApplicationRelationsSchema'
import type { ApplicationWithRelations } from './ApplicationRelationsSchema'
import { ScopingFromRepoSchema } from './ScopingFromRepoSchema';

/////////////////////////////////////////
// SCOPING FROM REPO RELATION SCHEMA
/////////////////////////////////////////

export type ScopingFromRepoRelations = {
  application: ApplicationWithRelations;
};

export type ScopingFromRepoWithRelations = z.infer<typeof ScopingFromRepoSchema> & ScopingFromRepoRelations

export const ScopingFromRepoWithRelationsSchema: z.ZodType<ScopingFromRepoWithRelations> = ScopingFromRepoSchema.merge(z.object({
  application: z.lazy(() => ApplicationWithRelationsSchema),
}))